import React from 'react';
import Heading from '../Headers/Heading';
import Button from '../Misc/Button';
import chairmanImg from '../../assets/images/drmo.jpg';

function ServicesSection() {
    return (
        <div className="services" style={{ background: '#fff' }}>
            <div className="services-wrapper">
                                <div className="container">
                    <div className="row align-items-center py-5">
                        <div className="col-lg-5 text-center text-lg-start mb-4 mb-lg-0">
                            <img src={chairmanImg} alt="Chairman" style={{ maxWidth: '100%', borderRadius: '12px', boxShadow: '0 4px 24px rgba(0,0,0,0.08)' }} />
                                </div>
                        <div className="col-lg-7">
                            <h2 className="heading heading-very-large dark-1 mb-3"></h2>
                            <div className="paragraph dark-1 mb-4" style={{ fontSize: '1.6rem' }}>
                                I am honored to welcome you to the official website of the Dr. Mohammed Audu Foundation. This is a platform built on compassion, resilience, and an unwavering commitment to mental health and social wellbeing of humanity.
                            </div>
                            <div className="paragraph dark-1 mb-4" style={{ fontSize: '1.6rem' }}>
                            We invite you to collaborate with us, explore our programs, connect with our services, and become part of a vision that’s bigger than any one individual. Whether you’re seeking help, offering support, partnering or simply learning more you are welcome here.
                            <br />Together, we can build a healthier, more compassionate society one life at a time.
                            <br /><br />Welcome to the Dr. Mohammed Audu Foundation.
                            <br />Welcome to hope. Welcome to healing.
                            </div>
                            <div className="chairman-signature mt-4">
                                <div style={{ fontStyle: 'italic', fontSize: '1.5rem' }}>Signed</div>
                                <div className="signature-font" style={{ fontFamily: 'cursive', fontSize: '2.2rem', margin: '0.2em 0' }}>Dr. Mohammed Audu</div>
                                <div style={{ fontSize: '1.5rem' }}>Founder/CEO</div>
                    </div>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ServicesSection;
